import { AccountPosition, PositionRecommendation } from '../types';

// Color utility functions
export const getRankColor = (rank: number) => {
  if (rank === 1) return 'bg-yellow-100 text-yellow-800';
  if (rank === 2) return 'bg-gray-100 text-gray-800';
  if (rank === 3) return 'bg-orange-100 text-orange-800';
  return 'bg-blue-100 text-blue-800';
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'RECOMMENDED':
      return 'bg-blue-100 text-blue-800';
    case 'APPROVED':
      return 'bg-green-100 text-green-800';
    case 'REJECTED':
      return 'bg-red-100 text-red-800';
    case 'FILLED':
      return 'bg-purple-100 text-purple-800';
    case 'CANCELLED':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getPriorityColor = (priority: string) => {
  switch (priority) {
    case 'HIGH':
      return 'bg-red-100 text-red-800';
    case 'MEDIUM':
      return 'bg-yellow-100 text-yellow-800';
    case 'LOW':
      return 'bg-green-100 text-green-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const isExpired = (expiresAt: string) => {
  if (!expiresAt) return false;
  return new Date(expiresAt) < new Date();
};

// Formatting utilities
export const formatCurrency = (value: number | undefined | null) => {
  if (value === undefined || value === null) {
    return 'N/A';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);
};

export const formatPercentage = (value: number | undefined | null) => {
  if (value === undefined || value === null) {
    return 'N/A';
  }
  return `${value.toFixed(2)}%`;
};

// Grouping utilities
export const groupRecommendationsByBatch = (
  recommendations: PositionRecommendation[],
) => {
  const grouped: Record<string, PositionRecommendation[]> = {};

  recommendations.forEach((recommendation) => {
    const batchId = recommendation.batchId || 'unknown';
    if (!grouped[batchId]) {
      grouped[batchId] = [];
    }
    grouped[batchId].push(recommendation);
  });

  // Sort recommendations within each batch by rank
  Object.keys(grouped).forEach((batchId) => {
    grouped[batchId].sort((a, b) => (a.rank || 0) - (b.rank || 0));
  });

  return grouped;
};

// Filter utilities
export const filterPositions = (
  positions: AccountPosition[],
  filterStatus: string,
  showExpired: boolean,
) => {
  return positions.filter((position) => {
    if (filterStatus !== 'ALL' && position.status !== filterStatus) {
      return false;
    }
    if (!showExpired && isExpired(position.expiresAt || '')) {
      return false;
    }
    return true;
  });
};
